import React from 'react';
import { Box } from '@mui/material';
import LogsTable from '../../../../../components/LogsTable';
import { getLocationId } from '../../../utils/locationTransformers';

const HistoryTab = ({ selectedLocation }) => {
  const locationId = getLocationId(selectedLocation);

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <LogsTable locationId={locationId} />
    </Box>
  );
};

export default HistoryTab;
